export const URLS = {
  OFFERS_BY_MERCHANT: '/app/transactions/offers',
  OFFER_PREVIEW: '/app/transactions/offers',
  TRANSACTIONS: '/app/transactions',
  OFFERS: '/app/offers',
  CUSTOMER: '/app/customers',
  LOGIN_CODE: '/app/auth/login/code',
  LOGIN: '/app/auth/login',
  PRE_CUSTOMER: '/app/pre-customers',
  UPGRADE_CUSTOMER: '/app/pre-customers/upgrade',
  VALIDATION_CUSTOMER: '/app/customers/validation',
  VALIDATE_CUSTOMER: '/app/customers/validate',
  PRE_LOANS: '/app/pre-loans',
  PAYMENTS: '/app/transactions/payments',
  CREATE_CREDIT_CARD: '/app/customers/card',
  GET_CARD: '/app/customers/card',
  MERCHANT_TRANSACTIONS: '/app/transactions',
  PUT_RECORD: '/api/metrics/put_record',
  GET_ORDER: '/app/transactions/order',
};

export const URLS_MOCK = {
  OFFERS_BY_MERCHANT: '/app/transactions/offers',
  OFFERS_BY_MERCHANT_AMOUNT: '/app/transactions/offers\\?amount=600.00',
  OFFER_PREVIEW: '/app/transactions/offers/preview',
  OFFER_PREVIEW_3:
    '/app/transactions/offers/preview\\?offer_id=c6e5e010-dc14-4f36-8176-adf256c84b0d\\&amount=600.00',
  OFFER_PREVIEW_6:
    '/app/transactions/offers/preview\\?offer_id=7a2e59a0-738f-4cd9-b4a0-09bfedbb542c\\&amount=600.00',
  OFFER_PREVIEW_12:
    '/app/transactions/offers/preview\\?offer_id=2ef46a70-be2e-4207-ab84-fba828a74cb3\\&amount=600.00',
};
